import MoneyView from "components/common/views/MoneyView";
import useAppContext from "utilities/hooks/useAppContext";
import './BookingTotalCharge.scss'

type BookingTotalChargePropsType = {
    total: number,
    additionalCharge?: number,
    paid?: number | null
}

const BookingTotalCharge = (props: BookingTotalChargePropsType) => {
    const context = useAppContext();
    return (
        <div className="border theme-border px-2">
            <table className="booking-total-charge">
                <thead className="booking-total-charge-head">
                    <tr className="booking-total-charge-tr">
                        <th className="app-label">{context.t('accommodation.booking.reservation')}</th>
                        <th className="app-label">{context.t('accommodation.booking.additionalCharges')}</th>
                        <th className="app-label">{context.t('fields.paidAmount.shortName')}</th>
                        <th className="app-label">{context.t('fields.total.name')}</th>
                    </tr>
                </thead>
                <tbody className="booking-total-charge-body">
                    <tr className="booking-total-charge-tr">
                        <td>{props.total}</td>
                        <td>{props.additionalCharge || '-'}</td>
                        <td className="text-red-800 dark:text-red-200">{props.paid || '-'}</td>
                        <td className="text-center font-bold">
                            <MoneyView value={(props.total + (props.additionalCharge || 0)) - (props.paid || 0)} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default BookingTotalCharge;
